var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Parallax',{attrs:{"y":-100}},[_c('div',{staticClass:"ScrollCta"},[_c('div',{staticClass:"ScrollCta__label rotate caption",domProps:{"innerHTML":_vm._s(_vm.ui.scroll)}}),_c('div',{staticClass:"ScrollCta__line"})])])}
var staticRenderFns = []

export { render, staticRenderFns }